import {
  Card, CardContent, Typography, Grid, Button, Box, SvgIcon,
} from '@mui/material';
import { Link } from 'react-router-dom';
import React from 'react';
import config from '../../config';
import { ReactComponent as Logo } from '../../assets/images/notFound.svg';

export default function DashboardNotFoundPage() {
  return (
    <Grid container sx={{ minHeight: '85vh' }}>
      <Grid item xs={12}>
        <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 100px)' }}>
          <Card sx={{
            p: { md: '50px', sm: '10px' },
            width: { lg: '50%', md: '100%' },
            justifyContent: 'center',
          }}
          >
            <CardContent>
              <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                mb: 4,
              }}
              >
                <SvgIcon
                  component={Logo}
                  inheritViewBox
                  sx={{
                    width: 100, height: 100,
                  }}
                />
              </Box>
              <Typography variant="h3" color="primary" align="center" sx={{ mb: 2 }}>Something is wrong</Typography>
              <Typography align="center">The page you are looking for has been moved, removed, renamed, or might not exist!</Typography>
              <Box sx={{
                width: '100%', display: 'flex', justifyContent: 'center', mt: 2,
              }}
              >
                <Link to={config.routes.homePath}>
                  <Button variant="outlined">Go to dashboard</Button>
                </Link>
              </Box>
            </CardContent>
          </Card>
        </Grid>

      </Grid>
    </Grid>
  );
}
